import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import router from './router'
import ElementUI from './config/elementConfig.js'
import VueClipboard from 'vue-clipboard2'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  InfiniteScroll
} from 'mint-ui'
import './config/mint-variables.css'
require('es6-promise').polyfill()
require('isomorphic-fetch')
import './assets/css/base.css'
import filters from './assets/js/filters'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale' //locale兼容
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import store, {
  defaultNodeAddress
} from './store'
import '@/assets/js/flexible.js'
import '@/assets/js/flexible_css.js'
import '@/assets/css/app.scss'
import Chain33Rpc from 'chain33-rpc-api'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import 'whatwg-fetch'

Vue.use(VueI18n)
Vue.use(InfiniteScroll)
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) //注册全局filter；
})

// 注册 查询区块链的接口
Vue.prototype.$chain33Rpc = new Chain33Rpc(defaultNodeAddress, null, (error) => {
  if (error.message === 'Failed to fetch') {
    store.commit('connectStatusOff')
  }
  throw error
})

// 处理index含有参数的跳转
router.beforeEach(function (to, from, next) {
  NProgress.start();
  if (to.name === 'indexPage') {
    if (to.query.address) {
      next({
        path: '/addressDetail',
        replace: true,
        query: to.query
      })
    } else if (to.query.height) {
      next({
        path: '/blockDetail',
        replace: true,
        query: to.query
      })
    } else if (to.query.hash) {
      next({
        path: '/tradeHash',
        replace: true,
        query: to.query
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

// 中英语言包
const i18n = new VueI18n({
  locale: 'cn', // 语言标识
  messages: {
    'en': Object.assign(require('./assets/lang/en'), enLocale), //与Element的语言包进行合并
    'cn': Object.assign(require('./assets/lang/cn'), zhLocale),
  },
})
locale.i18n((key, value) => i18n.t(key, value)) //为了兼容element插件的多语言切换

router.afterEach(() => {
  NProgress.done();
})

// raven监控  

// if (process.env.VUE_APP_IS_SENTRY === 'true') {
//   Raven
//     .config('https://' + process.env.VUE_APP_IS_SENTRY_CODE + '@sentry.bityuan.com/7', {
//       realease: require('../package.json').version
//     })
//     .addPlugin(RavenVue, Vue)
//     .install()
// }

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')